import notificationApi from '../api/notificationApi';

class NotificationService {
  // GET /notifications/me - Get user notifications
  async getNotifications(params = {}) {
    const queryParams = new URLSearchParams({
      limit: (params.limit || 50).toString(),
      skip: (params.skip || 0).toString(),
      unreadOnly: (params.unreadOnly || false).toString()
    });

    if (params.type) {
      queryParams.append('type', params.type);
    }

    const response = await notificationApi.get(`/notifications/me?${queryParams}`);
    return response;
  }

  // GET /notifications/unread-count - Get unread count
  async getUnreadCount() {
    try {
      const response = await notificationApi.get('/notifications/unread-count');
      return response?.data?.count || response?.count || 0;
    } catch (error) {
      console.warn('Failed to get unread count:', error?.message);
      return 0;
    }
  }

  // PATCH /notifications/:notificationId/read - Mark as read
  async markAsRead(notificationId) {
    const response = await notificationApi.patch(`/notifications/${notificationId}/read`);
    return response;
  }

  // PATCH /notifications/read-all - Mark all as read
  async markAllAsRead() {
    const response = await notificationApi.patch('/notifications/read-all');
    return response;
  }

  // DELETE /notifications/:notificationId - Delete notification
  async deleteNotification(notificationId) {
    const response = await notificationApi.delete(`/notifications/${notificationId}`);
    return response;
  }

  // POST /notifications - Create notification (for admin use)
  async createNotification(data) {
    const response = await notificationApi.post('/notifications', data);
    return response;
  }

  // GET /health - Health check
  async healthCheck() {
    try {
      const response = await notificationApi.get('/health');
      return response?.data || response;
    } catch (error) {
      return { status: 'error', message: error?.message };
    }
  }
}

export default new NotificationService();
